<template>
  <v-app id="authApp">
    <v-container :fluid="true" class="d-flex justify-center" width="100%">
      <div class="d-none">
        &nbsp;
        <button @click="logout()">LOGOUT</button>
        <br />Realm: {{ realm }}-{{ mfConfig.api }}
      </div>
    </v-container>
  </v-app>
</template>

<script>
import AuthStatusMixin from "@/mixins/AuthStatus.js";
import eventsMixin from "@/mixins/events.js";
export default {
  name: "AuthtenticationApp",
  mixins: [AuthStatusMixin, eventsMixin],
  props: ["mfConfig", "realm"],
  data: function () {
    return {
      errorMessage: false,
    };
  },
  mounted() {
  },
};
</script>
